export const STATE_KEY = 'shopifyProducts';

export function reducer(state = {}, action) {
  switch(action.type) {
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shopifyProducts.js